export const NCD_INITIATE = `/initiate/transaction/ncd`;
export const NCD_INITIATE_SUCCESS = '/initiate/transaction/ncd/:transId/success';
